/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const findForwarders = /* GraphQL */ `query FindForwarders {
  findForwarders
}
` as GeneratedQuery<
  APITypes.FindForwardersQueryVariables,
  APITypes.FindForwardersQuery
>;
export const findManufacturerCountryOfOrigins = /* GraphQL */ `query FindManufacturerCountryOfOrigins {
  findManufacturerCountryOfOrigins
}
` as GeneratedQuery<
  APITypes.FindManufacturerCountryOfOriginsQueryVariables,
  APITypes.FindManufacturerCountryOfOriginsQuery
>;
export const findDeliveryPreferentialOriginDocumentsByFilter = /* GraphQL */ `query FindDeliveryPreferentialOriginDocumentsByFilter($filter: String) {
  findDeliveryPreferentialOriginDocumentsByFilter(filter: $filter) {
    id
    delivery {
      deliveryNoteNumber
      productCode
      purchaseOrderNumber
      purchaseOrderLineNumber
      factoryCommercialInvoiceNumber
      transportEquipmentNumber
      materialCountryOfOrigin
      transportationMode
      carrier
      forwarder
      billOfLadingNumber
      shipmentType
      departureDate
      dischargeDate
      factoryCode
      __typename
    }
    preferentialOriginDocument {
      number
      type
      quantity
      destinationCountry
      stpCode
      stpCodeMasterData
      stpQualifier
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindDeliveryPreferentialOriginDocumentsByFilterQueryVariables,
  APITypes.FindDeliveryPreferentialOriginDocumentsByFilterQuery
>;
export const findDeliveryPreferentialOriginDocumentsByReportCriteria = /* GraphQL */ `query FindDeliveryPreferentialOriginDocumentsByReportCriteria(
  $criteria: ReportCriteriaInput!
) {
  findDeliveryPreferentialOriginDocumentsByReportCriteria(criteria: $criteria) {
    id
    delivery {
      deliveryNoteNumber
      productCode
      purchaseOrderNumber
      purchaseOrderLineNumber
      factoryCommercialInvoiceNumber
      transportEquipmentNumber
      materialCountryOfOrigin
      transportationMode
      carrier
      forwarder
      billOfLadingNumber
      shipmentType
      departureDate
      dischargeDate
      factoryCode
      __typename
    }
    preferentialOriginDocument {
      number
      type
      quantity
      destinationCountry
      stpCode
      stpCodeMasterData
      stpQualifier
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindDeliveryPreferentialOriginDocumentsByReportCriteriaQueryVariables,
  APITypes.FindDeliveryPreferentialOriginDocumentsByReportCriteriaQuery
>;
